<template>
    <button class="bg-tc-blue-1 border border-tc-blue-1 rounded-full text-white w-full h-45px text-20"
            @click="onClick()"
            :class="[setPadding,setDisabledClass]">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: 'BlueBtn',
    props: {
        paddingClass: { type: String, default: '' },
        isDisabled: { type: Boolean, default: false}
    },
    computed: {
        setPadding: function() {
            if (this.paddingClass == '') {
                return 'px-4 py-1';
            }
            return this.paddingClass;
        },
        setDisabledClass: function(){
            if(this.isDisabled){
                return 'bg-tc-gray-4 text-tc-gray-1 border-tc-gray-4'
            }
            return ''
        }
    },
    methods:{
        onClick: function(){
            this.$emit('onClick');
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
